import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTbLgt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "8.1248789mm",
	height: "9.0123186mm",
	viewBox: "0 0 8.1248789 9.0123186",
	id: "svg1",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("g", {
		id: "layer1",
		transform: "translate(-141.28749,-123.03125)",
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "matrix(0.79375,0,0,0.79375,135.82493,118.89985)",
			strokeWidth: 2,
			id: "g2-9",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "m 8,16 4,-8 4,8",
				stroke: "#ffffff",
				strokeWidth: 2.5,
				fill: "none",
				id: "path1-5"
			}), /* @__PURE__ */ _jsx("path", {
				d: "m 8,16 4,-8 4,8",
				stroke: "#008000",
				fill: "none",
				id: "path2"
			})]
		})
	})]
});
export default SvgTbLgt;
